import { FilterableInterface } from './filterable.interface';
import { OperationMode } from './operation-mode';

export class Operation implements FilterableInterface {
  constructor(
    public hash?: string,
    public name?: string,
    public index?: number,
    public mode?: OperationMode,
    public active?: boolean,
    public modeName?: string
  ) { }

  get filterableData() {
    return this.name.toLowerCase();
  }

  clone() {
    return new Operation (
      this.hash,
      this.name,
      this.index,
      this.mode,
      this.active,
      this.modeName,
    );
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/operation.ts